// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1LVt6","label":"Radio_label__u5df_","checkMark":"Radio_checkMark__3bGPB","disabled":"Radio_disabled__26Bj4"};